<template>
    <div class="order-personages-repeater">
        <div class="order-personages-repeater__items">
            <transition-group name="fade-down">
                <OrderPersonageForm
                    v-for="(item, index) in personages"
                    :key="index"
                    v-model="personages[index]"
                    :languages="languages"
                    :common-language="commonLanguage"
                    :initial-personage="initialPersonage"
                    :can-delete="personages.length > 1"
                    :limit="limit"
                    @delete="onDelete"
                />
            </transition-group>
        </div>
        <button :class="['button', 'button--fullwidth']" type="button" @click="add">
            + Add another role
        </button>
    </div>
</template>

<script>
import OrderPersonageForm from '../OrderPersonageForm/OrderPersonageForm';
export default {
    name: 'OrderPersonagesRepeater',
    components: {
        OrderPersonageForm,
    },
    props: {
        languages: {
            type: Array,
            default: () => [],
        },
        commonLanguage: {
            type: String,
            required: true,
        },
        defaultSpeakers: {
            type: Array,
            default: () => [],
        },
        limit: {
            type: Number,
            default: 0,
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            personages: [],
            initialPersonage: {
                name: undefined,
                language: undefined,
                speaker: undefined,
            },
        };
    },
    watch: {
        personages: {
            deep: true,
            handler() {
                this.update(this.personages);
            },
        },
    },
    methods: {
        add() {
            this.personages.push({ ...this.initialPersonage });
        },
        update(event) {
            this.$emit('update:modelValue', event);
        },
        onDelete(event) {
            this.personages.splice(this.personages.indexOf(event), 1);
        },
    },
};
</script>

<style lang="scss" src="./OrderPersonagesRepeater.scss"></style>
